module.exports = __webpack_public_path__ + "static/image/history/pc/202209.jpg?c8b42755";